import { FunctionComponent } from 'react';
import { DetailsModalCommon } from '../../../shared';
import { DetailsContentAdmin } from '../DetailsContentAdmin';

export const DetailsModalAdmin: FunctionComponent = () => {
  return <DetailsModalCommon ContentComponent={DetailsContentAdmin} />;
};
